import {
  ACCOUNT_SERVICE,
  API_VERSION,
  IF_MATCH,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_QUICKBOOKS_AUDIT = `${ACCOUNT_SERVICE}/quickbooks-audits`;

export const quickBooksAudit = {
  getAll: async ({
    filters,
    sort,
    params,
    signal,
    top,
    skip,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS_AUDIT}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
      params,
      signal,
      top,
      skip,
    });
    return apiRequest(options, toastMessageConfig);
  },
  sync: async (item, toastMessageConfig) => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS_AUDIT}/${item.id}/sync`,
      method: "put",
      headers: {
        [X_API_VERSION]: API_VERSION,
        [IF_MATCH]: item.modifiedOn,
      },
      toastMessageConfig,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
